module.exports = __webpack_public_path__ + "img/responsive hospitium-14.ca38e56e.jpg";